import { ReactNode } from 'react';
import { Stack, Typography } from '@optimus-web/core';
import { BarItem, UpperPart } from './styles';

interface RepaymentBarItemProps {
    label: ReactNode;
    height: number;
    upperPartValue: ReactNode;
    upperPartHeight: number;
}

export const RepaymentBarItem: React.FC<RepaymentBarItemProps> = ({
    label,
    height,
    upperPartValue,
    upperPartHeight,
}) => (
    <Stack vertical alignment="end" itemAlignment="center" spacing="200">
        <Typography textStyle="bodyMediumStrong" as="div">
            {upperPartValue}
        </Typography>
        <BarItem height={height}>
            <UpperPart height={upperPartHeight} />
        </BarItem>
        {label}
    </Stack>
);
